import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-hot-toast';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, isApproved, isPending, loading } = useAuth();

  useEffect(() => {
    // Show message when user is not authenticated
    if (!loading && !isAuthenticated) {
      toast.error('Bạn cần đăng nhập để truy cập trang này.');
    }
  }, [isAuthenticated, loading]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (isPending) {
    return <Navigate to="/pending-approval" />;
  }

  if (!isApproved) {
    return <Navigate to="/pending-approval" />;
  }

  return children;
};

export default PrivateRoute; 
